import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { Layout } from "../../components";
import SearchList from "./SearchList";
import SearchHeader from "./SearchHeader";
import SearchResultHeader from "./SearchResultHeader";
import SearchRecommend from "./SearchRecommend";
import { useStore } from "../../store";
import { getStorage } from "../../utils/storage";
const Search = () => {
  const { tag } = useParams<{ tag: string }>();
  const {
    searchStore: { onUpdateCurrentSearch },
  } = useStore();

  useEffect(() => {
    if (!tag) return;
    if (getStorage("select_type") === "hashtag") {
      onUpdateCurrentSearch({
        searchValue: tag,
      });
    }
    // eslint-disable-next-line
  }, [tag]);

  const headerProps = {
    isTransparent: false,
    children: tag ? <SearchResultHeader tag={tag} /> : <SearchHeader />,
  };

  const SearchBody = () => {
    if (tag) return <SearchList tag={tag} />;
    return <SearchRecommend />;
  };

  return (
    <Layout headerProps={headerProps} isTopMargin>
      <SearchBody />
    </Layout>
  );
};

export default Search;
